module.exports = __webpack_public_path__ + "assets/images/meeting-ee8cb4d5a0bc4a379c60831eaa2518fd.jpg";